const getIsAssistedSalesEnabled = configuration =>
  configuration?.app?.assistedSales?.enabled ?? true;

const getIsAssistedSalesDisabledPopinEnabled = configuration =>
  configuration?.app?.assistedSales?.disabledPopin ?? false;

module.exports = {
  getIsAssistedSalesEnabled,
  getIsAssistedSalesDisabledPopinEnabled,
};
